import {ContextStateSymbol, ContextUpdateSymbol} from '@/components/global/Context.vue';
import {fileToImage, resizeImage, removeAccessToken} from "@/utils/helpers";
import {handleSuccess} from "@/utils/helpers";

export const userData = {
    data() {
        return {
            userData: {
                CBGName: null,
                email: null,
                password: null,
                firstname: null,
                lastname: null,
                gender: 'None',
                location: null,
                phone: null,
                avatarUrl: null,
                passwordCreatedAt: null,
                nickname: null,
            },
        }
    },
    inject: {
        context: { from: ContextStateSymbol, default: null },
        updateContext: { from: ContextUpdateSymbol, default: null },
    },
    watch: {
        'context.userData': {
            handler() {
                this.userData = this.context.userData || {};
            },
            deep: true
        }
    },
    computed: {
        lastPasswordUpdate() {
            const inputDate = new Date(this.userData.passwordCreatedAt);
            const month = String(inputDate.getMonth() + 1).padStart(2, '0');
            const day = String(inputDate.getDate()).padStart(2, '0');

            return `${month}/${day}/${String(inputDate.getFullYear()).slice(-2)}`;
        },
        nameLetter() {
            if (this.userData.nickname) {
                return this.userData.nickname[0].toUpperCase();
            } else {
                return '';
            }
        }
    },
    methods: {
        handlePhotoChange(event) {
            const selectedFile = event.target.files[0];

            if (selectedFile) {
                const reader = new FileReader();
                reader.onload = async (e) => {
                    const img = await fileToImage(selectedFile);
                    this.tempUserData.avatar = resizeImage(img);
                };
                reader.readAsDataURL(selectedFile);
            } else {
                this.tempUserData.avatarUrl = null;
            }
        },
        resetPhoto() {
            this.tempUserData.avatar = null;
        },
        logOut(isReset = false) {
            const isRemember = localStorage.getItem('cbgIsRemember');

            if (this.updateContext) {
                this.updateContext('isAuth', false);
                !isReset && this.updateContext('isOpen', false);
                !isReset ? this.updateContext('step', 0) : this.updateContext('step', 1);

                handleSuccess('cbg_auth_logout', {});
                this.updateContext('userData', {});

                setTimeout(() => {
                    if (!isReset) {
                        isRemember ? localStorage.removeItem('cbgContext') : sessionStorage.removeItem('cbgContext');
                    }
                    removeAccessToken();
                    localStorage.removeItem('cbgIsRemember');
                }, 0);
            }
        },
    },

    mounted() {
        this.userData = this.context.userData || {};
    }
}